<template>
  <div class=" height-100">
    <div
      id="inner-chat-cart-list"
      class="history-inner-chat-cards"
      :style="`height: calc(100% - ${innerHeight.cards});`">
      <div
        v-if="loading"
        class="height-100 flex">
        <div
          class="my-auto mx-auto">
          <sIcon
            color="#ced8d7"
            size="40"
            spin
            type="loading"/>
        </div>
      </div>
      <InnerChatCards
        v-else
        sort="desc"
        :value="mutateValue"
        @answer="openComment"
        @changeViewedMessages="$_changeViewedMessages"
        @loadPage="$emit('loadPage')"/>
    </div>
    <HistoryInnerChatInput
      class="history-inner-chat-input"
      :files.sync="files"
      :hash-items="sprHashItems"
      :loading="loading"
      small
      :style="`height: ${innerHeight.chat};`"
      :text.sync="text"
      :user-items="sprUsers"
      @resize="resize"
      @send="send">
      <template
        v-slot:beforeInput>
        <CommentInputBlock
          :loading="loading"
          :value="answerComment ? {title: answerComment.userLogin} : null"
          @close="answerComment=null">
          <InnerChatMessage
            slot="message"
            readonly
            :value="answerComment"/>
        </CommentInputBlock>
      </template>
    </HistoryInnerChatInput>
  </div>
</template>
<script>
import InnerChatCards from 'components/common/blocks/inner-chat/InnerChatCards.vue'
import CommentInputBlock from 'components/common/blocks/history/CommentInputBlock.vue'
import InnerChatMessage from 'components/common/blocks/inner-chat/InnerChatMessage.vue'
import HistoryInnerChatInput from 'components/common/blocks/inner-chat/HistoryInnerChatInput.vue'

import CloneDeep from 'lodash/cloneDeep'
import { innerChatMixin } from 'mixins'

export default {
  name: 'historyInnerChat',
  mixins: [innerChatMixin],
  data() {
    return {
      text: '',
      files: [],
      innerHeight: {
        cards: '98px',
        chat: '88px',
        input: '46px'
      },
      chatInputHeight: 98,
      fileModalShow: false,
      answerComment: null
    }
  },
  methods: {
    resize(val) {
      this.$nextTick(() => {
        const maxHeight = (document.documentElement.offsetHeight / 2 ) - 55

        const height = val > maxHeight ? maxHeight : val
        this.innerHeight.cards = `${height}px`
        this.innerHeight.chat = `${height - 10}px`
      })
    },
    getBidsForTag(tender) {
      if (!tender.bids?.length || !tender.lots?.length) {
        return []
      }
      return tender.bids.flatMap(bid =>
        bid.bidDetails.map(bidDetail => ({
          id: bidDetail.id,
          name: bid.bidderInfo?.organizationName,
          lotTitle: tender.lots.find(i => i.lotId === bidDetail.lotId).title,
          lotId: bidDetail.lotId
        }))
      )
    },
    openComment(answer) {
      this.answerComment = answer
    },
    async send(messageObject) {
      if (this.answerComment) {
        messageObject.parentMessageId = this.answerComment.id
      }
      const modelMessage = {
        entity: {
          entityType: 'Tender',
          entityId: this.item.tenderId.toString(),
          properties: [
            {'key': 'NUMBER','value': this.item.tenderNumber.toString()},
            {'key': 'TITLE','value': this.item.title},
            {'key': 'ORGANIZATION_IT_ID','value': this.item.organizer.organizationItId.toString()},
          ]
        },
        messag: messageObject
      }
      this.$_sendNewMessage(modelMessage)
        .then(() => {
          this.answerComment = null
        })
        .catch(() => {
          this.text = messageObject.value
          this.files = messageObject.files
        })
    },
    async createHashItems() {
      const sprHashItems = []
      if (this.item) {
        sprHashItems.push({
          id: this.item.tenderId,
          type: 'tender',
          number: this.item.tenderNumber,
          title: this.item?.title?.trim(),
        })
        if (this.item.lots?.length) {
          this.item.lots.forEach((lot) => {
            sprHashItems.push({
              id: lot.lotId,
              tenderId: this.item.tenderId,
              type: 'lot',
              number: lot.lotNumber,
              title: lot.title?.trim(),
            })
          })
        }
        const bids = CloneDeep(this.getBidsForTag(this.item))
        if (bids?.length) {
          bids.forEach((bid, bidIndex) => {
            sprHashItems.push({
              id: bid.id,
              tenderId: this.item.tenderId,
              type: 'bid',
              number: bidIndex + 1,
              title: `${bid.name.trim()} ${this.$t('Tenders.ToLot').toLowerCase()}: ${bid.lotTitle.trim()}`,
            })
          })
        }
        await this.$store.dispatch('innerChat/setSprHash', {items: sprHashItems})
      }
    }
  },
  computed: {
    mutateValue: {
      get: function () {
        const result = CloneDeep(this.value)
        if (!result) {
          return {}
        }
        if (!result.messages?.length) {
          return result
        }
        result.messages = result.messages.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())
        return result
      }
    },
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || !oldValue.tenderId && newValue.tenderId) {
          this.createHashItems()
        }
      }
    }
  },
  async mounted() {
    this.$root.$on('InnerChatNewMessagesSuccessed', this.$_setMessageState)
  },
  beforeDestroy() {
    this.$root.$off('InnerChatNewMessagesSuccessed', this.$_setMessageState)
  },
  /* beforeDestroy() {
    this.scrollUnSubs()
  }, */
  props: {
    value: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    InnerChatCards,
    InnerChatMessage,
    CommentInputBlock,
    HistoryInnerChatInput
  }
}
</script>
<style>
#history-tabs .not_commented {
  padding-bottom: 0 !important;
}
</style>
<style scoped lang="scss">
.history-inner-chat-cards {
  overflow: auto;
  //transition: all 0.25s;
}
.history-inner-chat-input {
  position: relative;
  width: 100%;
  background: var(--v-main__light_green-base);
  border-top: 2px solid var(--color-main-green);
  z-index: 1;
  padding-top: 10px;
  padding-bottom: 0px;
  margin-top: 10px;
}
</style>
